import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ProductAvailabilityProps } from "./product-availability.types";
import { availabilityDataCopy } from "~/modules/Product/copies";

export const useProductAvailability = ({
  product,
  inventoryConfig,
  isInventoryAvailable,
}: ProductAvailabilityProps) => {
  const { t } = useTranslation();

  const isAvailable = useMemo(() => {
    return product.available;
  }, [product]);

  const availabilityData = useMemo(
    () =>
      !product.kit
        ? availabilityDataCopy(
            t,
            inventoryConfig?.type?.toUpperCase(),
            inventoryConfig,
          )
        : t("product.always"),
    [product, inventoryConfig],
  );

  const textDisable = useMemo(() => {
    if (!isAvailable) return `${t("product.not_available")}`;
    if (!isInventoryAvailable) return `${t("product.text_not_available")}`;
    return availabilityData;
  }, [product, availabilityData, isInventoryAvailable]);

  return {
    t,
    product,
    inventoryConfig,
    isInventoryAvailable,
    textDisable,
    isAvailable,
  };
};
